import { render } from "./HeaderAnth.vue?vue&type=template&id=7b72f8fb"
import script from "./HeaderAnth.js?vue&type=script&lang=js&external"
export * from "./HeaderAnth.js?vue&type=script&lang=js&external"

import "./HeaderAnth.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__